/**
 * Created by jonlazarini on 06/05/17.
 */
export const tokens = {
    apiKey: "AIzaSyDIhQaejLFQYzDkthqYCRh5pY3F1vNd-Nw",
    authDomain: "fir-chat-app-a9869.firebaseapp.com",
    databaseURL: "https://fir-chat-app-a9869.firebaseio.com",
    projectId: "fir-chat-app-a9869",
    storageBucket: "fir-chat-app-a9869.appspot.com",
    messagingSenderId: "574620779413"
}


// WEBPACK FOOTER //
// ./src/config/tokens.js